import React from "react";
import * as Chakra from "@chakra-ui/react";
import { QuillEditor } from "./quill/quill";
import striptags from 'striptags'

interface BodyInputTextareaProps {
  title: string;
  body: string;
  placeholder: string;
  number: number;
  value: string;
  onChange: any;
}

const BodyInputTextarea = ({
  title,
  body,
  placeholder,
  number,
  value,
  onChange,
}: BodyInputTextareaProps): React.ReactElement => {
  return (
    <Chakra.Box width="100%" pt="44px">
      <Chakra.Text
        fontSize="14px"
        fontWeight="500"
        lineHeight="20px"
        letterSpacing="0.11px"
        color="#000"
      >
        {title}
      </Chakra.Text>
      <Chakra.Text
        fontSize="14px"
        fontWeight="300"
        lineHeight="20px"
        letterSpacing="0.11px"
        color="#000"
        pb="35px"
        maxWidth="480px"
      >
        {body}
      </Chakra.Text>
      <Chakra.Box
        width="100%"
        borderRadius="2px"
        borderWidth="1px"
        borderStyle="solid"
        borderColor="#bababa"
        _placeholder={{ fontSize: "14px", color: "#000" }}
        position="relative"
        fontSize="14px"
        minHeight="100px"
        maxWidth="100%"
        p={4}
      >
        <Chakra.Text
          fontSize="13px"
          color="#c8232a"
          position="absolute"
          top={3}
          right={3}
        >
          {number ? number - striptags(value, [], "").length : ""}
        </Chakra.Text>
        <QuillEditor
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          count={number}
        />
      </Chakra.Box>
    </Chakra.Box>
  );
};

export default BodyInputTextarea;
